import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchAssortmentItems } from '../api/fetchAssortmentItems'
import { REQUEST_ASSORTMENT_ITEMS } from '../constants'

export const requestAssortmentItems = createAsyncThunk(
  REQUEST_ASSORTMENT_ITEMS,
  fetchAssortmentItems
)
